import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWallet = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M21.639 14.396H17.59a2.693 2.693 0 0 1 0-5.383h4.048M18.049 11.643h-.312" />
      <path d="M7.748 3h8.643a5.25 5.25 0 0 1 5.248 5.248v7.177a5.25 5.25 0 0 1-5.248 5.247H7.748A5.25 5.25 0 0 1 2.5 15.425V8.248A5.25 5.25 0 0 1 7.748 3M7.036 7.538h5.399" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgWallet);
export default ForwardRef;
